module.exports = import("https://cdn.jsdelivr.net/npm/three@0.129.0/build/three.module.js/+esm");;